export const replaceUnderscoresAndCapitalise = (str: string) => {
  const strWithoutUnderscores = str.replaceAll('_', ' ').trim();

  return (
    strWithoutUnderscores.charAt(0).toUpperCase() +
    strWithoutUnderscores.substring(1)
  );
};
